/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAbsence } from '../models/work-absence';
import { WorkContainer } from '../models/work-container';
import { WorkDocument } from '../models/work-document';
import { WorkEvent } from '../models/work-event';
import { WorkEventInvitation } from '../models/work-event-invitation';
import { WorkItem } from '../models/work-item';
import { WorkItemsForProjectDto } from '../models/work-items-for-project-dto';
import { WorkNews } from '../models/work-news';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProfileDto } from '../models/work-profile-dto';
import { WorkProjectrevenue } from '../models/work-projectrevenue';
import { WorkTask } from '../models/work-task';
import { WorkTasksForProjectDto } from '../models/work-tasks-for-project-dto';
import { WorkUpdateEventInvitationDto } from '../models/work-update-event-invitation-dto';
import { WorkUpdateProfileDto } from '../models/work-update-profile-dto';
import { WorkUser } from '../models/work-user';
import { WorkUsertraining } from '../models/work-usertraining';

@Injectable({ providedIn: 'root' })
export class WorkMyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `myAbsencesV1ControllerGetMyAbsences()` */
  static readonly MyAbsencesV1ControllerGetMyAbsencesPath = '/v1/my/absences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myAbsencesV1ControllerGetMyAbsences()` instead.
   *
   * This method doesn't expect any request body.
   */
  myAbsencesV1ControllerGetMyAbsences$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsence>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyAbsencesV1ControllerGetMyAbsencesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsence>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myAbsencesV1ControllerGetMyAbsences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myAbsencesV1ControllerGetMyAbsences(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsence>> {
    return this.myAbsencesV1ControllerGetMyAbsences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsence>>): Array<WorkAbsence> => r.body)
    );
  }

  /** Path part for operation `myAbsencesV1ControllerGetMyApprovals()` */
  static readonly MyAbsencesV1ControllerGetMyApprovalsPath = '/v1/my/absences/approvals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myAbsencesV1ControllerGetMyApprovals()` instead.
   *
   * This method doesn't expect any request body.
   */
  myAbsencesV1ControllerGetMyApprovals$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsence>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyAbsencesV1ControllerGetMyApprovalsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsence>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myAbsencesV1ControllerGetMyApprovals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myAbsencesV1ControllerGetMyApprovals(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsence>> {
    return this.myAbsencesV1ControllerGetMyApprovals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsence>>): Array<WorkAbsence> => r.body)
    );
  }

  /** Path part for operation `myContactsV1ControllerContactPersons()` */
  static readonly MyContactsV1ControllerContactPersonsPath = '/v1/my/contacts/contactPersons';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myContactsV1ControllerContactPersons()` instead.
   *
   * This method doesn't expect any request body.
   */
  myContactsV1ControllerContactPersons$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUser>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyContactsV1ControllerContactPersonsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUser>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myContactsV1ControllerContactPersons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myContactsV1ControllerContactPersons(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUser>> {
    return this.myContactsV1ControllerContactPersons$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUser>>): Array<WorkUser> => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerFindAll()` */
  static readonly MyEventsV1ControllerFindAllPath = '/v1/my/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindAll$Response(
    params?: {
      onlyFutureEvents?: any;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEvent>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerFindAllPath, 'get');
    if (params) {
      rb.query('onlyFutureEvents', params.onlyFutureEvents, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEvent>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindAll(
    params?: {
      onlyFutureEvents?: any;
    },
    context?: HttpContext
  ): Observable<Array<WorkEvent>> {
    return this.myEventsV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEvent>>): Array<WorkEvent> => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerFindById()` */
  static readonly MyEventsV1ControllerFindByIdPath = '/v1/my/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEvent>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEvent> {
    return this.myEventsV1ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEvent>): WorkEvent => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerFindInvitationByEventId()` */
  static readonly MyEventsV1ControllerFindInvitationByEventIdPath = '/v1/my/events/{id}/invitation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerFindInvitationByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindInvitationByEventId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerFindInvitationByEventIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerFindInvitationByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myEventsV1ControllerFindInvitationByEventId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.myEventsV1ControllerFindInvitationByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerAccept()` */
  static readonly MyEventsV1ControllerAcceptPath = '/v1/my/events/{id}/invitation/{invitationId}/accept';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerAccept()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerAccept$Response(
    params: {
      invitationId: number;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerAcceptPath, 'patch');
    if (params) {
      rb.path('invitationId', params.invitationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerAccept$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerAccept(
    params: {
      invitationId: number;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.myEventsV1ControllerAccept$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerDecline()` */
  static readonly MyEventsV1ControllerDeclinePath = '/v1/my/events/{id}/invitation/{invitationId}/decline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerDecline()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerDecline$Response(
    params: {
      invitationId: number;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerDeclinePath, 'patch');
    if (params) {
      rb.path('invitationId', params.invitationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerDecline$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerDecline(
    params: {
      invitationId: number;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.myEventsV1ControllerDecline$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerAcceptWithAccessKey()` */
  static readonly MyEventsV1ControllerAcceptWithAccessKeyPath = '/v1/my/events/{id}/invitation/{invitationId}/acceptWithAccessKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerAcceptWithAccessKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerAcceptWithAccessKey$Response(
    params: {
      invitationId: number;
      accessKey?: string;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerAcceptWithAccessKeyPath, 'patch');
    if (params) {
      rb.path('invitationId', params.invitationId, {});
      rb.query('accessKey', params.accessKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerAcceptWithAccessKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerAcceptWithAccessKey(
    params: {
      invitationId: number;
      accessKey?: string;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.myEventsV1ControllerAcceptWithAccessKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `myEventsV1ControllerDeclineWithAccessKey()` */
  static readonly MyEventsV1ControllerDeclineWithAccessKeyPath = '/v1/my/events/{id}/invitation/{invitationId}/declineWithAccessKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myEventsV1ControllerDeclineWithAccessKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerDeclineWithAccessKey$Response(
    params: {
      invitationId: number;
      accessKey?: string;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyEventsV1ControllerDeclineWithAccessKeyPath, 'patch');
    if (params) {
      rb.path('invitationId', params.invitationId, {});
      rb.query('accessKey', params.accessKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myEventsV1ControllerDeclineWithAccessKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myEventsV1ControllerDeclineWithAccessKey(
    params: {
      invitationId: number;
      accessKey?: string;
      body: WorkUpdateEventInvitationDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.myEventsV1ControllerDeclineWithAccessKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `myNewsV1ControllerFindAllNewsPaginated()` */
  static readonly MyNewsV1ControllerFindAllNewsPaginatedPath = '/v1/my/news';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myNewsV1ControllerFindAllNewsPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  myNewsV1ControllerFindAllNewsPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyNewsV1ControllerFindAllNewsPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkNews>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myNewsV1ControllerFindAllNewsPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myNewsV1ControllerFindAllNewsPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.myNewsV1ControllerFindAllNewsPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `myNewsV1ControllerFindOneNews()` */
  static readonly MyNewsV1ControllerFindOneNewsPath = '/v1/my/news/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myNewsV1ControllerFindOneNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  myNewsV1ControllerFindOneNews$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyNewsV1ControllerFindOneNewsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myNewsV1ControllerFindOneNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myNewsV1ControllerFindOneNews(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.myNewsV1ControllerFindOneNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `myProfileV1ControllerProfile()` */
  static readonly MyProfileV1ControllerProfilePath = '/v1/my/profile/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProfileV1ControllerProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProfileV1ControllerProfile$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProfileDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProfileV1ControllerProfilePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProfileDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProfileV1ControllerProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProfileV1ControllerProfile(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkProfileDto> {
    return this.myProfileV1ControllerProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProfileDto>): WorkProfileDto => r.body)
    );
  }

  /** Path part for operation `myProfileV1ControllerUpdate()` */
  static readonly MyProfileV1ControllerUpdatePath = '/v1/my/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProfileV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myProfileV1ControllerUpdate$Response(
    params: {
      body: WorkUpdateProfileDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProfileV1ControllerUpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProfileV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  myProfileV1ControllerUpdate(
    params: {
      body: WorkUpdateProfileDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.myProfileV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetProjectsByContainer()` */
  static readonly MyProjectsV1ControllerGetProjectsByContainerPath = '/v1/my/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetProjectsByContainer()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetProjectsByContainer$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContainer>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetProjectsByContainerPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContainer>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetProjectsByContainer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetProjectsByContainer(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkContainer>> {
    return this.myProjectsV1ControllerGetProjectsByContainer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContainer>>): Array<WorkContainer> => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetItemsForProject()` */
  static readonly MyProjectsV1ControllerGetItemsForProjectPath = '/v1/my/projects/{id}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetItemsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetItemsForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItemsForProjectDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetItemsForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItemsForProjectDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetItemsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetItemsForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkItemsForProjectDto> {
    return this.myProjectsV1ControllerGetItemsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItemsForProjectDto>): WorkItemsForProjectDto => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetItemByCalculationitemIdForProject()` */
  static readonly MyProjectsV1ControllerGetItemByCalculationitemIdForProjectPath = '/v1/my/projects/{id}/itemByCalculationId/{calculationitemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetItemByCalculationitemIdForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetItemByCalculationitemIdForProject$Response(
    params: {
      id: number;
      calculationitemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetItemByCalculationitemIdForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('calculationitemId', params.calculationitemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetItemByCalculationitemIdForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetItemByCalculationitemIdForProject(
    params: {
      id: number;
      calculationitemId: number;
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.myProjectsV1ControllerGetItemByCalculationitemIdForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetTasksForProject()` */
  static readonly MyProjectsV1ControllerGetTasksForProjectPath = '/v1/my/projects/{id}/tasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetTasksForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetTasksForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTasksForProjectDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetTasksForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTasksForProjectDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetTasksForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetTasksForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTasksForProjectDto> {
    return this.myProjectsV1ControllerGetTasksForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTasksForProjectDto>): WorkTasksForProjectDto => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetTaskForProject()` */
  static readonly MyProjectsV1ControllerGetTaskForProjectPath = '/v1/my/projects/{projectId}/tasks/{taskId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetTaskForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetTaskForProject$Response(
    params: {
      projectId: number;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetTaskForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetTaskForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetTaskForProject(
    params: {
      projectId: number;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.myProjectsV1ControllerGetTaskForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetDocumentsForTask()` */
  static readonly MyProjectsV1ControllerGetDocumentsForTaskPath = '/v1/my/projects/{projectId}/documentsForTask/{taskId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetDocumentsForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetDocumentsForTask$Response(
    params: {
      projectId: number;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetDocumentsForTaskPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetDocumentsForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetDocumentsForTask(
    params: {
      projectId: number;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.myProjectsV1ControllerGetDocumentsForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetAppointmentsByProject()` */
  static readonly MyProjectsV1ControllerGetAppointmentsByProjectPath = '/v1/my/projects/{id}/appointments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetAppointmentsByProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetAppointmentsByProject$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetAppointmentsByProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetAppointmentsByProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetAppointmentsByProject(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.myProjectsV1ControllerGetAppointmentsByProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `myProjectsV1ControllerGetProjectrevenuesForProject()` */
  static readonly MyProjectsV1ControllerGetProjectrevenuesForProjectPath = '/v1/my/projects/{id}/projectrevenues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myProjectsV1ControllerGetProjectrevenuesForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetProjectrevenuesForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectrevenue>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyProjectsV1ControllerGetProjectrevenuesForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectrevenue>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myProjectsV1ControllerGetProjectrevenuesForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myProjectsV1ControllerGetProjectrevenuesForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectrevenue>> {
    return this.myProjectsV1ControllerGetProjectrevenuesForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectrevenue>>): Array<WorkProjectrevenue> => r.body)
    );
  }

  /** Path part for operation `myUsertrainingsV1ControllerGetMyTrainings()` */
  static readonly MyUsertrainingsV1ControllerGetMyTrainingsPath = '/v1/my/trainings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myUsertrainingsV1ControllerGetMyTrainings()` instead.
   *
   * This method doesn't expect any request body.
   */
  myUsertrainingsV1ControllerGetMyTrainings$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUsertraining>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyService.MyUsertrainingsV1ControllerGetMyTrainingsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUsertraining>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myUsertrainingsV1ControllerGetMyTrainings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myUsertrainingsV1ControllerGetMyTrainings(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUsertraining>> {
    return this.myUsertrainingsV1ControllerGetMyTrainings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUsertraining>>): Array<WorkUsertraining> => r.body)
    );
  }

}
